import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import * as bootstrap from 'bootstrap';
import { trackClickEvent } from '../../events/clicks-tracker';

@customElement('tm-tpc-corrector-limit-error-modal')
export class TmTPCCorrectorLimitErrorModal extends LitElement {
    createRenderRoot() {
        return this;
    }

    showModal() {
        const modalElement = document.querySelector('#tm-tpc-corrector-limit-error-modal');
        if (modalElement) {
            const bootstrapModal = bootstrap.Modal.getOrCreateInstance(modalElement);
            bootstrapModal.show();
            modalElement.addEventListener(
                'hidden.bs.modal',
                () => {
                    this.emitClose();
                },
                {
                    once: true,
                }
            );
        }
    }

    emitClose() {
        this.dispatchEvent(new CustomEvent('close'));
    }

    dismissModal() {
        const modalElement = document.querySelector('#tm-tpc-corrector-limit-error-modal');
        if (modalElement) {
            const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
            bootstrapModal.hide();
        }
        this.emitClose();
    }

    firstUpdated() {
        this.showModal();
    }

    render() {
        return html`
            <div
                class="modal fade tm-tpc-corrector-limit-error-modal"
                id="tm-tpc-corrector-limit-error-modal"
                tabindex="-1"
                aria-hidden="true"
            >
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="tm-tpc-corrector-limit-error-modal-header">
                            <span></span>
                            <img
                                src="/img/logo-black.svg"
                                alt="Todamateria"
                                class="tm-tpc-corrector-limit-error-modal-header-logo"
                            />
                            <button
                                type="button"
                                class="tm-tpc-corrector-limit-error-modal-header-close"
                                aria-label="Close"
                                @click=${this.dismissModal}
                            >
                                <span class="icon icon-012-close"></span>
                            </button>
                        </div>
                        <div class="tm-tpc-corrector-limit-error-modal-title">
                            Você atingiu o limite diário!
                        </div>
                        <div
                            class="tpc-corrector-question-view-tmplus-card tpc-corrector-question-view-tmplus-card--modal"
                        >
                            <div class="tpc-corrector-question-view-tmplus-card-bg"></div>
                            <div class="tpc-corrector-question-view-tmplus-card-content">
                                <div class="tpc-corrector-question-view-tmplus-card-title">
                                Ainda tem dúvidas?
                                </div>
                                <div class="tpc-corrector-question-view-tmplus-card-description">
                                    Assine por menos de R$1 por dia e faça quantas perguntas quiser com registro completo do histórico
                                </div>
                                <a
                                    href="/tmplus/"
                                    class="ds-button ds-button--tmplus--invert"
                                    @click="${() => {
                                        trackClickEvent('cta-tmplus-assistant-popup-limit');
                                    }}"
                                    >Quero mais
                                    <span class="icon icon-034-dash-arrow"></span>
                                </a>
                                <div class="tpc-corrector-question-view-tmplus-card-safe">
                                    <span class="icon icon-061-unlock"></span>Compra 100% segura
                                </div>
                            </div>
                        </div>
                        <button
                            class="tm-tpc-corrector-limit-error-modal-ignore"
                            @click=${this.dismissModal}
                        >
                            Ignorar
                        </button>
                    </div>
                </div>
            </div>
        `;
    }
}
